import { audioManager } from './../objects/AudioManager';
import { app } from './../app.world';
import { FW } from './../framework/Framework';
import { BaseScreen } from './BaseScreen';

declare const $: any;

export class MainCover extends BaseScreen {

    private _sprite:GAF.GAFMovieClip;

    constructor() {
        super();

        $('.kidsafe').css('display', 'block');

        this._sprite = FW.gafManager.createMovieClip('worlds', 'lib_main_cover');
        FW.root.addChild(this._sprite);

        this.setupButton(this._sprite['buttonPlay'], () => {
            app.showGameCover();

            audioManager.playCoverIntro([
                {index: 1, delay: 0},
                {index: 2, delay: 8000}
            ])
        }, 'Play');

        this.setupButton(this._sprite['buttonAbout'], () => {
            app.showAbout();
        }, 'About');

        let isan = new PIXI.Text('ISAN# 0000-0004-EA31-0000-E-0000-0000-W', {
            fill: 0xFFFFFF,
            fontSize: 10,
            dropShadow: true,
            dropShadowDistance: 0.3,
            dropShadowBlur: 3
        });
        this._sprite.addChild(isan);
        isan.position.set((FW.stageWidth - isan.width) / 2 + 6, FW.stageHeight - 18);
    }

    public get sprite():GAF.GAFMovieClip {
        return this._sprite;
    }

    public dispose():void {
        $('.kidsafe').css('display', 'none');
        super.dispose();
    }

}


// WEBPACK FOOTER //
// ./src/worlds/MainCover.ts